import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import GeoContext from 'contexts/geoContext'
import { LUXURY_ESCAPES } from 'constants/brands'
import config from 'constants/config'
import HeadData from 'components/Common/HeadData'

function CruiseHeadData() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)

  const headTitle = config.BRAND === LUXURY_ESCAPES
    ? intl.formatMessage({
        id: 'VIk5wF8xt7',
        defaultMessage: 'Luxury Cruises',
        description: 'Page title for luxury cruises search page in the cruise section',
      })
    : intl.formatMessage({
        id: 'mRmRwIDmvB',
        defaultMessage: 'Cruises',
        description: 'Page title for cruises search page in the cruise offer or booking section',
      })

  const description = config.BRAND === LUXURY_ESCAPES
    ? intl.formatMessage({
        id: 'vYD2IcLXCk',
        defaultMessage: 'Embark on a life changing cruise. Curated by travel experts to save you time. Featuring luxury accommodation, select dining and exclusive inclusions.',
        description: 'HTML meta description for luxury cruises search page',
      })
    : undefined

  return <HeadData title={intl.formatMessage({ id: 'Oaxy0J/zia', defaultMessage: '{headTitle} - {siteTitle} {regionCode}', description: 'SEO page title for cruises page combining page title, site name and region code' }, { headTitle, siteTitle: config.title, regionCode: currentRegionCode })} description={description} />
}

export default CruiseHeadData
